<template>
  <div>
    <b-modal
      :id="`edit-branch-${id}`"
      :title="$t('menu.settings.hierarchies.titleUpdateBranch')"
      size="lg"
      ref="my-edit-branch"
    >
      <div class="mb-4">
        <label for="editFilial"
          >{{ $t('menu.settings.hierarchies.labels.branch') }}:</label
        >
        <input
          type="text"
          v-model="editCorporateName"
          class="form-control"
          id="editCorporateName"
        />
        <div class="invalid-feedback">
          {{ $t('menu.settings.hierarchies.feedbackInformBranch') }}
        </div>
      </div>

      <div class="mb-4">
        <label for="editDescription"
          >{{ $t('menu.settings.hierarchies.labels.description') }}:</label
        >
        <input
          type="text"
          v-model="editDescription"
          class="form-control"
          id="editDescription"
        />
        <div class="invalid-feedback">
          {{ $t('menu.settings.hierarchies.feedbackInformDescription') }}
        </div>
      </div>

      <div class="customParent">
        <div
          class="row mt-4 mb-4 customFields"
          v-for="(sf, i) in editSecFields"
          :key="i"
        >
          <div class="col-4">
            <label
              >{{ $t('menu.settings.hierarchies.labels.customField') }}:</label
            >
            <input type="text" v-model="sf.key" class="form-control cusField" />
          </div>

          <div class="col-5">
            <label>{{ $t('menu.settings.hierarchies.labels.value') }}:</label>
            <input
              type="text"
              v-model="sf.value"
              class="form-control cusValue"
            />
          </div>

          <div class="btn-div col-2 mt-4">
            <button @click="removeGroup(i)" class="btn btn-trash">
              <div class="mask"></div>
              <font-awesome-icon :icon="['fas', 'trash-alt']" />
            </button>

            <button @click="addGroup" class="btn btn-add ml-1">
              <font-awesome-icon :icon="['fas', 'plus']" />
            </button>
          </div>
        </div>
      </div>

      <div
        class="row mt-4 mb-4 customFields"
        v-for="(branch, j) in branches"
        :key="editSecFields.length + j"
      >
        <div class="col-4">
          <input
            type="text"
            class="form-control cusField"
            :placeholder="
              $t('menu.settings.hierarchies.placeholderCustomField')
            "
          />
        </div>

        <div class="col-5">
          <input
            type="text"
            class="form-control cusValue"
            :placeholder="$t('menu.settings.hierarchies.placeholderValue')"
          />
        </div>

        <div class="btn-div col-2">
          <button
            @click="removeGroupEmpty(editSecFields.length + j)"
            class="btn btn-trash"
          >
            <div class="mask"></div>
            <font-awesome-icon :icon="['fas', 'trash-alt']" />
          </button>

          <button @click="addGroup" class="btn btn-add ml-1">
            <font-awesome-icon :icon="['fas', 'plus']" />
          </button>
        </div>
      </div>

      <div class="btn-div" :style="{ display: controlAddButton }">
        <button @click="addGroup" class="btn btn-add">
          <font-awesome-icon :icon="['fas', 'plus']" />
        </button>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="w-100">
          <button @click="editBranch" class="float-right btn btn-primary ml-2">
            {{ $t('menu.settings.hierarchies.buttonSave') }}
          </button>
          <button
            @click="cancel(clearBranch())"
            class="float-right btn btn-secondary"
          >
            {{ $t('menu.settings.hierarchies.buttonCancel') }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import swal from 'sweetalert';

export default {
  name: 'modal-edit-branch',
  props: [
    'id',
    'corporate_name',
    'type',
    'secondary_fields',
    'description',
    'page',
  ],
  data() {
    return {
      editDescription: '',
      editCorporateName: '',
      editType: null,
      editSecFields: null,
      branches: [],
      controlAddButton: '',
    };
  },

  methods: {
    ...mapActions('branches', [
      'updateBranch',
      'getBranchesIH2',
      'listBranchesIh2',
    ]),

    hideModal() {
      this.$refs['my-edit-branch'].hide();
    },

    clearBranch() {
      this.branches.splice(0);
    },

    editBranch() {
      if (this.editCorporateName === '') {
        document
          .getElementById('editCorporateName')
          .classList.add('is-invalid');
      } else {
        document
          .getElementById('editCorporateName')
          .classList.remove('is-invalid');
      }

      if (this.editCorporateName !== '') {
        const customFields = document.querySelectorAll('.customFields');
        const cusField = document.querySelectorAll('.cusField');
        const cusValue = document.querySelectorAll('.cusValue');

        this.editSecFields.splice(0);

        for (let i = 0; i < customFields.length; i += 1) {
          this.editSecFields.push({
            key: cusField[i].value,
            value: cusValue[i].value,
          });
        }

        const editObj = {
          data: {
            description: this.editDescription,
            corporate_name: this.editCorporateName,
            secondary_fields: this.editSecFields,
          },
          token: JSON.parse(localStorage.getItem('_indecx')).token,
          branchId: this.id,
        };
        this.branches.splice(0);
        this.updateBranch(editObj).then(async () => {
          swal({
            title: this.$t(
              'menu.settings.hierarchies.messages.changesSaved.title',
            ),
            text: this.$t(
              'menu.settings.hierarchies.messages.changesSaved.description',
            ),
            icon: 'success',
          }).then(() => {
            this.hideModal();
          });

          await this.getBranchesIH2({
            companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
            token: JSON.parse(localStorage.getItem('_indecx')).token,
            type: 'ih2',
            limit: 10,
            page: this.page,
          });

          await this.listBranchesIh2({
            companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
            token: JSON.parse(localStorage.getItem('_indecx')).token,
          });
        });
      }
    },

    addGroup() {
      const customFields = document.querySelectorAll('.customFields');

      if (customFields.length < 10) {
        this.controlAddButton = 'none';

        this.branches.push('test');
      }
    },

    removeGroup(num) {
      const customInputs = document.querySelectorAll('.customFields');

      if (customInputs.length === 1) {
        customInputs[0].remove();
        this.branches.splice(0);
        this.controlAddButton = 'block';
      } else {
        customInputs[num].remove();
        this.branches.pop('test');
      }
    },

    removeGroupEmpty(num) {
      const customInputs = document.querySelectorAll('.customFields');

      if (customInputs.length === 1) {
        customInputs[0].remove();
        this.branches.splice(0);
        this.controlAddButton = 'block';
      } else {
        customInputs[num].remove();
        this.branches.pop('test');
        this.controlAddButton = 'none';
      }
    },
  },

  mounted() {
    this.editDescription = this.description;
    this.editCorporateName = this.corporate_name;
    this.editType = this.type;
    this.editSecFields = this.secondary_fields;

    if (this.secondary_fields.length > 0) {
      this.controlAddButton = 'none';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.btn-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-trash {
  position: relative;
  color: red;
  border: 1px solid red;
  &:hover {
    color: $white;
    background-color: red;
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}

.btn-add {
  color: $primary;
  border: 1px solid $primary;
  &:hover {
    color: $white;
    background-color: $primary;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/ih2/modal-edit-branch.vue